import { ControlValueAccessor } from '@angular/forms';
import { Directive, signal } from '@angular/core';

@Directive()
export abstract class BaseValueAccessor<T> implements ControlValueAccessor {
  private _value = signal<T>(undefined);

  // Angular's ControlValueAccessor contract expects a single callback that gets
  // replaced on every registration. It relies on that to detach a control:
  // cleanUpControl() overwrites the callback with a noop that throws
  // "There is no FormControl instance attached ...". Accumulating callbacks
  // keeps both that noop and callbacks of already-detached controls alive.
  private changeCallback: (value: T) => void = () => undefined;
  private touchCallback: () => void = () => undefined;

  get value(): T {
    return this._value();
  }

  set value(value: T) {
    if (value !== undefined && this._value() !== value) {
      this._value.set(value);
      this.changeCallback(value);
      this.touch();
    }
  }

  touch() {
    this.touchCallback();
  }

  writeValue(value: T) {
    this._value.set(value);
  }

  registerOnChange(fn: (value: T) => void) {
    this.changeCallback = fn;
  }

  registerOnTouched(fn: () => void) {
    this.touchCallback = fn;
  }
}
